// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
export default {
  config: {
    apiKey: "AIzaSyBSpUgS93xgnPP8pY3pNtbcWDIrNciNf-Y",
    authDomain: "ios-barbell-notebook.firebaseapp.com",
    databaseURL: "https://ios-barbell-notebook.firebaseio.com",
    projectId: "ios-barbell-notebook",
    storageBucket: "ios-barbell-notebook.appspot.com",
    messagingSenderId: "823078598738",
    appId: "1:823078598738:web:47d41c9c850fa1ada6478b",
    measurementId: "G-XLXR4LK5EF"
  }
}

// apiKey: "AIzaSyBSpUgS93xgnPP8pY3pNtbcWDIrNciNf-Y",
// authDomain: "ios-barbell-notebook.firebaseapp.com",
// databaseURL: "https://ios-barbell-notebook.firebaseio.com",
// projectId: "ios-barbell-notebook",
// storageBucket: "ios-barbell-notebook.appspot.com",
// messagingSenderId: "823078598738",
// appId: "1:823078598738:web:47d41c9c850fa1ada6478b",
// measurementId: "G-XLXR4LK5EF"

// export default {
//   config: {
//     apiKey: "",
//     authDomain: "",
//     databaseURL: "",
//     projectId: "",
//     storageBucket: "",
//     messagingSenderId: "",
//     appId: "",
//   }
// }



// WEBPACK FOOTER //
// ./src/firebase/credentials.js